module.exports = __webpack_public_path__ + "img/magento-setup-tuning_small.17356c9f.webp";